import { Language, LanguageMap, LanguageMapping } from '@vendasta/galaxy/i18n';

export { Language, LanguageMapping, LanguageMap };
